import { Box, Typography } from '@mui/material';
import CustomLoader from 'components/shared/CustomLoader/CustomLoader';
import { LayoutType } from 'model/deals.model';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Filters } from './Filters';
import Grid from './Grid';
import { muiStyles } from './muiStyles';
import Table from './Table';
import { useContacts } from './useContacts';
import { useSaveToMyContacts } from './useSaveToMyContacts';

const BusinessesMain = () => {
  const { id } = useParams();
  const {
    data,
    loading,
    totalCount,
    totalPages,
    currentPage,
    handlePageChange,
    handleRowsChange,
    limit,
    value,
    debouncedValue,
    handleChange,
    clearInput,
  } = useContacts(id ?? '');
  const { postContact, modal, closeModal, openModal } = useSaveToMyContacts();

  const [layout, setLayout] = useState<LayoutType>(LayoutType.KANBAN);

  const handleLayoutChange = (_: SyntheticEvent, newValue: LayoutType) => {
    setLayout(newValue);
  };

  useEffect(() => {}, []);

  if (loading || !data) return <CustomLoader open />;

  const Content = layout === LayoutType.KANBAN ? Grid : Table;

  return (
    <Box sx={muiStyles.container}>
      <Box sx={muiStyles.header}>
        <Typography variant='responsiveHeading3'>Contacts</Typography>
        <Filters
          layout={layout}
          onLayoutChange={handleLayoutChange}
          value={value}
          debouncedValue={debouncedValue}
          handleChange={handleChange}
          clearInput={clearInput}
        />
      </Box>
      <Content
        contacts={data.contacts}
        totalCount={totalCount}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        handleRowsChange={handleRowsChange}
        limit={limit}
        postContact={postContact}
        openModal={openModal}
      />

      {/* <CustomModal handleClose={closeModal} open={modal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Box
            sx={{
              backgroundColor: zeplinColor.Neutral1,
            }}
          >
            Hello
            <>Hello</>
            <>Hello</>
            <>Hello</>
            <>Hello</>
            <>Hello</>
          </Box>
        </Box>
      </CustomModal> */}
    </Box>
  );
};

export default BusinessesMain;
